<div class="pricing-display w-full min-w-0 max-w-full p-4">
  <div class="flex justify-between gap-4">
    <h1 class="mb-4 text-2xl font-semibold">Product Pricing</h1>
  </div>

  @if (error) {
    <div class="alert alert-error my-2">{{ error }}</div>
  }

  <div class="sticky top-16 z-10 mb-4 flex justify-between bg-base-100 py-2">
    <div
      class="pricing-display-tabs tabs-boxed tabs justify-center"
      role="tablist"
    >
      @for (tabId of allTabs; track tabId) {
        <a
          class="tab whitespace-nowrap"
          role="tab"
          [class.tab-active]="currentTab === tabId"
          (click)="switchTab(tabId)"
        >
          <span class="mx-4 whitespace-nowrap">{{ tabLabel(tabId) }}</span>
        </a>
      }
    </div>
    <label class="form-control ml-4">
      <div class="label">
        <span class="label-text whitespace-nowrap">Price lock level</span>
      </div>
      <select
        class="select select-bordered select-sm text-left"
        [(ngModel)]="priceLockLevel"
        (ngModelChange)="loadPricing()"
        [disabled]="loading"
      >
        @for (level of priceLockLevelOptions; track level) {
          <option [ngValue]="level.value">{{ level.label }}</option>
        }
      </select>
    </label>
  </div>

  <div class="m-auto w-fit max-w-full">
    @if (isDbTab(currentTab) && loading) {
      <span class="loading loading-spinner loading-lg"></span>
    } @else if (isDbTab(currentTab)) {
      @if (currentTab === 'desktop') {
        @for (section of desktopSections; track section.title) {
          @if (groupsForDesktopSection(section).length > 0) {
            <section class="mb-10">
              <h2 class="mb-4 text-xl font-semibold">{{ section.title }}</h2>
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-md">
                  <thead class="text-base font-medium">
                    <tr>
                      <td class="w-1 whitespace-nowrap">Code</td>
                      <td>Product Title</td>
                      <td class="w-1 whitespace-nowrap px-8 text-right">
                        1 year
                      </td>
                      <td class="w-1 whitespace-nowrap px-8 text-right">
                        2 year
                      </td>
                      <td class="w-1 whitespace-nowrap px-8 text-right">
                        3 year
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      group of groupsForDesktopSection(section);
                      track group.product_id;
                      let i = $index
                    ) {
                      <tr
                        [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
                        class="hover:bg-base-300"
                      >
                        <td class="w-1 whitespace-nowrap">
                          {{ group.code }}
                        </td>
                        <td>{{ group.title }}</td>
                        <td class="w-1 whitespace-nowrap px-8 text-right">
                          @if (
                            price12Month(group, section.useSitePrice) != null
                          ) {
                            {{
                              price12Month(group, section.useSitePrice)
                                | currency: 'USD'
                            }}
                          }
                        </td>
                        <td class="w-1 whitespace-nowrap px-8 text-right">
                          @if (
                            price24Month(group, section.useSitePrice) != null
                          ) {
                            {{
                              price24Month(group, section.useSitePrice)
                                | currency: 'USD'
                            }}
                          }
                        </td>
                        <td class="w-1 whitespace-nowrap px-8 text-right">
                          @if (
                            price36Month(group, section.useSitePrice) != null
                          ) {
                            {{
                              price36Month(group, section.useSitePrice)
                                | currency: 'USD'
                            }}
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </section>
          }
        }
      } @else if (currentTab === 'api') {
        @if (loading) {
          <span class="loading loading-spinner loading-lg"></span>
        } @else if (groupsForTab('api').length > 0) {
          <div
            class="overflow-x-auto rounded-lg border border-base-content/20"
          >
            <table class="table table-md">
              <thead class="text-base font-medium">
                <tr>
                  <td class="w-1 whitespace-nowrap">Code</td>
                  <td>Product Title</td>
                  <td class="w-1 whitespace-nowrap px-8 text-right">1 year</td>
                  <td class="w-1 whitespace-nowrap px-8 text-right">2 year</td>
                  <td class="w-1 whitespace-nowrap px-8 text-right">3 year</td>
                </tr>
              </thead>
              <tbody>
                @for (
                  group of groupsForTab('api');
                  track group.product_id;
                  let i = $index
                ) {
                  <tr
                    [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
                    class="hover:bg-base-300"
                  >
                    <td class="w-1 whitespace-nowrap">{{ group.code }}</td>
                    <td>{{ group.title }}</td>
                    <td class="w-1 whitespace-nowrap px-8 text-right">
                      @if (group.price_12_month != null) {
                        {{ group.price_12_month | currency: 'USD' }}
                      }
                    </td>
                    <td class="w-1 whitespace-nowrap px-8 text-right">
                      @if (group.price_24_month != null) {
                        {{ group.price_24_month | currency: 'USD' }}
                      }
                    </td>
                    <td class="w-1 whitespace-nowrap px-8 text-right">
                      @if (group.price_36_month != null) {
                        {{ group.price_36_month | currency: 'USD' }}
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else if (!loading) {
          <p class="text-base-content/70">No API pricing groups found.</p>
        }
      }
    } @else if (activeStaticTab) {
      <div class="max-w-6xl">
        @for (
          note of activeStaticTab.tabNotes ?? [];
          track noteIndex;
          let noteIndex = $index
        ) {
          <ng-container
            *ngTemplateOutlet="pricingNote; context: { note: note }"
          />
        }

        @for (
          section of activeStaticTab.sections;
          track sectionIndex;
          let sectionIndex = $index
        ) {
          <section class="mb-10">
            @if (section.title) {
              <h3 class="mb-4 text-lg font-semibold">{{ section.title }}</h3>
            }

            @if (sectionHasTable(section)) {
              <div
                class="overflow-x-auto rounded-lg border border-base-content/20"
              >
                <table class="table table-md">
                  @if (section.headers.length > 0) {
                    <thead class="text-base font-medium">
                      <tr>
                        @for (
                          header of section.headers;
                          track headerIndex;
                          let headerIndex = $index
                        ) {
                          @if (section.dynamicSource === 'cass-api') {
                            <td
                              class="whitespace-nowrap px-4"
                              [class.text-right]="
                                headerIndex > 1 && header !== ''
                              "
                            >
                              {{ header }}
                            </td>
                          } @else {
                            <td
                              class="whitespace-nowrap px-4"
                              [class.text-right]="
                                headerIndex > 0 && header !== ''
                              "
                            >
                              {{ header }}
                            </td>
                          }
                        }
                      </tr>
                    </thead>
                  }
                  <tbody>
                    @if (section.dynamicSource === 'cass-api') {
                      @for (
                        row of cassApiRows;
                        track row.code;
                        let rowIndex = $index
                      ) {
                        <tr
                          [ngClass]="{ 'bg-base-200': rowIndex % 2 === 0 }"
                          class="hover:bg-base-300"
                        >
                          <td class="whitespace-nowrap px-4">
                            {{ row.code }}
                          </td>
                          <td class="whitespace-nowrap px-4">
                            {{ row.title }}
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            {{ row.varianceCode }}
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price12Month != null) {
                              {{ row.price12Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price24Month != null) {
                              {{ row.price24Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price36Month != null) {
                              {{ row.price36Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            {{ row.volume }}
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            {{ row.perUnit }}
                          </td>
                        </tr>
                      }
                    } @else if (section.dynamicSource === 'data-retention') {
                      @for (
                        row of dataRetentionRows;
                        track row.varianceCode;
                        let rowIndex = $index
                      ) {
                        <tr
                          [ngClass]="{ 'bg-base-200': rowIndex % 2 === 0 }"
                          class="hover:bg-base-300"
                        >
                          <td class="whitespace-nowrap px-4">
                            {{ row.label }}
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            {{ row.varianceCode }}
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price12Month != null) {
                              {{ row.price12Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price24Month != null) {
                              {{ row.price24Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price36Month != null) {
                              {{ row.price36Month | currency: 'USD' }}
                            }
                          </td>
                        </tr>
                      }
                    } @else if (section.dynamicSource === 'toolkit') {
                      @for (
                        row of toolkitRows(section.dynamicCodes);
                        track rowIndex;
                        let rowIndex = $index
                      ) {
                        <tr [ngClass]="{ 'bg-base-200': rowIndex % 2 === 0 }">
                          <td class="whitespace-nowrap px-4">
                            {{ row.code }}
                          </td>
                          <td class="px-4">{{ row.title }}</td>
                          <td class="whitespace-nowrap px-4 text-right">
                            {{ row.evaluationFee }}
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price12Month != null) {
                              {{ row.price12Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price24Month != null) {
                              {{ row.price24Month | currency: 'USD' }}
                            }
                          </td>
                          <td class="whitespace-nowrap px-4 text-right">
                            @if (row.price36Month != null) {
                              {{ row.price36Month | currency: 'USD' }}
                            }
                          </td>
                        </tr>
                      }
                    } @else {
                      @for (
                        row of section.rows;
                        track rowIndex;
                        let rowIndex = $index
                      ) {
                        <tr
                          [ngClass]="{ 'bg-base-200': rowIndex % 2 === 0 }"
                          class="hover:bg-base-300"
                        >
                          @for (
                            cell of paddedRow(section, row);
                            track colIndex;
                            let colIndex = $index
                          ) {
                            <td
                              class="whitespace-nowrap px-4"
                              [class.text-right]="colIndex > 0"
                            >
                              {{ cell }}
                            </td>
                          }
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            }

            @if (section.notes?.length) {
              <div class="mt-4 space-y-2">
                @for (
                  note of section.notes;
                  track sectionNoteIndex;
                  let sectionNoteIndex = $index
                ) {
                  <ng-container
                    *ngTemplateOutlet="pricingNote; context: { note: note }"
                  />
                }
              </div>
            }
          </section>
        }
      </div>
    }
  </div>
</div>

<ng-template #pricingNote let-note="note">
  @switch (note.type) {
    @case ('heading') {
      <h2 class="mb-2 text-xl font-semibold">{{ note.text }}</h2>
    }
    @case ('paragraph') {
      <p class="mb-3 max-w-5xl text-base-content/90">{{ note.text }}</p>
    }
    @case ('list-item') {
      <ul class="mb-2 ml-6 max-w-5xl list-disc">
        <li class="text-base-content/90">{{ note.text }}</li>
      </ul>
    }
  }
</ng-template>
